import { Component } from '@angular/core';
import { TranslatePipe } from "@ngx-translate/core";

@Component( {
  selector: 'dynamica-footer',
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [
    TranslatePipe
  ],
  styleUrls: ['./footer.component.scss']
} )
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();

}
